import Vue from 'vue'
import store from "@/store/store";
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'

import TestReferenceModel from "@/components/Test/TestReferenceModel";

import SuperBomList from '@/components/SuperBom/SuperBomList'
import SuperBom from '@/components/SuperBom/SuperBom'

import BatchRun from "@/components/BatchRun/BatchRun";
import BatchRunHistoryList from "@/components/BatchRun/BatchRunHistoryList";
import BatchRunHistoryItem from "@/components/BatchRun/BatchRunHistoryItem";

import CustomerOrderTable from "@/components/CoreComponent/CustomerOrder/CustomerOrderTable";
import CustomerOrderDetail from "@/components/CoreComponent/CustomerOrder/CustomerOrderDetail";

import CoreProductTable from "@/components/CoreComponent/Product/CoreProductTable";
import CoreProductDetail from "@/components/CoreComponent/Product/CoreProductDetail";
import CoreProductOrderTable from "@/components/CoreComponent/ProductOrder/CoreProductOrderTable";
import CoreProductOrderDetail from "@/components/CoreComponent/ProductOrder/CoreProductOrderDetail";
import CoreBatchRunDetail from "@/components/CoreComponent/BatchRun/CoreBatchRunDetail";
import CoreBatchRunTable from "@/components/CoreComponent/BatchRun/CoreBatchRunTable";

import ClientReplicaTable from "@/components/CoreReplica/ClientReplica/ClientReplicaTable";
import ClientReplicaDetail from "@/components/CoreReplica/ClientReplica/ClientReplicaDetail";
import CustomerOrderReplicaDetail from "@/components/CoreReplica/CustomerOrderReplica/CustomerOrderReplicaDetail";
import CustomerOrderReplicaTable from "@/components/CoreReplica/CustomerOrderReplica/CustomerOrderReplicaTable";
import QuoteReplicaDetail from "@/components/CoreReplica/QuoteReplica/QuoteReplicaDetail";
import QuoteReplicaTable from "@/components/CoreReplica/QuoteReplica/QuoteReplicaTable";
import ProductReplicaDetail from "@/components/CoreReplica/ProductReplica/ProductReplicaDetail";
import ProductReplicaTable from "@/components/CoreReplica/ProductReplica/ProductReplicaTable";
import BatchRunReplicaTable from "@/components/CoreReplica/BatchRunReplica/BatchRunReplicaTable";
import BatchRunReplicaDetail from "@/components/CoreReplica/BatchRunReplica/BatchRunReplicaDetail";

import TaskTypeTable from "@/components/Product/TaskType/TaskTypeTable";
import TaskTypeItem from "@/components/Product/TaskType/TaskTypeItem";
import TaskTemplateTable from "@/components/Product/TaskTemplate/TaskTemplateTable";
import TaskTemplateItem from "@/components/Product/TaskTemplate/TaskTemplateItem";
import TaskTemplateOneTable from "@/components/Product/Old/TaskTemplateOne/TaskTemplateOneTable";
import TaskTemplateOneItem from "@/components/Product/Old/TaskTemplateOne/TaskTemplateOneItem";

import BatchRunTable from "@/components/BatchRun/BatchRun/BatchRunTable";
import BatchRunItem from "@/components/BatchRun/BatchRun/BatchRunItem";

import BrandList from "@/components/Brand/BrandList";
import BrandProviderList from "@/components/Brand/BrandProviderList";
import BrandProviderItem from "@/components/Brand/BrandProviderItem";
import BrandComponentProviderComponent from "@/components/Brand/BrandComponentProviderComponent";
import BrandComponentList from "@/components/Brand/BrandComponentList";
import BrandComponentItem from "@/components/Brand/BrandComponentItem";

import AccountPermissionGroupList from "@/components/AccountPermissionGroupList";

import AuthLogin from "@/components/AuthLogin";
import AuthLogout from "@/components/AuthLogout";

// import MPNResearch from "@/components/MPNResearch/MPNResearch";
// import MPNResearchItem from "@/components/MPNResearch/MPNResearchItem";

import MPNChecking from "@/components/MPNChecking/MPNChecking";
import MPNCheckingItem from "@/components/MPNChecking/MPNCheckingItem";

import BaseTaskView from "@/components/BaseTaskView";

// import MPNResearchTest from "@/components/MPNResearchV2/MPNResearchTest";

import StoreFileList from "@/components/StoreFile/StoreFileList";
import StoreDocList from "@/components/StoreDoc/StoreDocList";
import StoreDocItem from "@/components/StoreDoc/StoreDocItem";

import QuoteList from "@/components/Quote/QuoteList";
import QuoteItem from "@/components/Quote/QuoteItem";

import BaseHistory from "@/components/BaseHistory/BaseHistory";

import BaseHistoryFile from "@/components/BaseHistoryFile/BaseHistoryFile";

import TimeTracker from "@/components/TimeTracker/TimeTracker";
import TimeTrackerEvent from "@/components/TimeTracker/TimeTrackerEvent";
import TimeTrackerAggregateEvent from "@/components/TimeTracker/TimeTrackerAggregateEvent";
import TimeTrackerHumanInfoModal from "@/components/TimeTracker/TimeTrackerHumanInfoModal";
import TimeTrackerHumanInfo from "@/components/TimeTracker/TimeTrackerHumanInfo";
import HRAdmin from "@/components/TimeTracker/HRAdmin";
import Contract from "@/components/TimeTracker/Contract";
import HRConfig from "@/components/TimeTracker/HRConfig";
import CalendarVacationTable from "@/components/HR/CalendarVacation/CalendarVacationTable";

import CustomerTable from "@/components/Product/Customer/CustomerTable";
import CustomerItem from "@/components/Product/Customer/CustomerItem";

import ClientTable from "@/components/CoreComponent/Client/ClientTable";
import ClientDetail from "@/components/CoreComponent/Client/ClientDetail";

import MachineTable from "@/components/Product/Machine/MachineTable";
import MachineItem from "@/components/Product/Machine/MachineItem";

import PartNumberTable from "@/components/CoreComponent/PartNumber/PartNumberTable";
import PartNumberDetail from "@/components/CoreComponent/PartNumber/PartNumberDetail";

import LibraryFileTable from "@/components/LibraryDoc/LibraryFile/LibraryFileTable";
import LibraryFileItem from "@/components/LibraryDoc/LibraryFile/LibraryFileItem";

import LibraryDocTable from "@/components/LibraryDoc/LibraryDoc/LibraryDocTable";
import LibraryDocItem from "@/components/LibraryDoc/LibraryDoc/LibraryDocItem";

import LibraryTopicTable from "@/components/LibraryDoc/LibraryTopic/LibraryTopicTable";
import LibraryTopicItem from "@/components/LibraryDoc/LibraryTopic/LibraryTopicItem";

import HistoryTable from "@/components/History/HistoryTable";
import HistoryItem from "@/components/History/HistoryItem";

import UserTable from "@/components/User/UserTable";
import UserItem from "@/components/User/UserItem";
import GroupTable from "@/components/User/GroupTable";

import CoreComponentTable from "@/components/CoreComponent/Component/ComponentTable";
import CoreCategoryTable from "@/components/CoreComponent/Category/CoreCategoryTable";
import CoreCategoryDetail from "@/components/CoreComponent/Category/CoreCategoryDetail";
import CoreSpecAttrDetail from "@/components/CoreComponent/SpecAttr/CoreSpecAttrDetail";
import CoreSpecAttrTable from "@/components/CoreComponent/SpecAttr/CoreSpecAttrTable";
import CoreSpecAttrComponentDetail from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentDetail";
import CoreSpecAttrComponentTable from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentTable";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import CoreBomSheetDetail from "@/components/CoreComponent/BomSheet/CoreBomSheetDetail";
import CorePickPlaceSheetDetail from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetDetail";
import CorePickPlaceSheetTable from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetTable";

import ComponentDetail from "@/components/CoreComponent/Component/ComponentDetail";
import CoreSubcategoryTable from "@/components/CoreComponent/Subcategory/CoreSubcategoryTable";
import CoreSubcategoryDetail from "@/components/CoreComponent/Subcategory/CoreSubcategoryDetail";
import CoreCasePackageTable from "@/components/CoreComponent/CasePackage/CoreCasePackageTable";
import CoreCasePackageDetail from "@/components/CoreComponent/CasePackage/CoreCasePackageDetail";
import BatchRunComponentDetail from "@/components/CoreComponent/BatchRunComponent/BatchRunComponentDetail";
import BatchRunComponentTable from "@/components/CoreComponent/BatchRunComponent/BatchRunComponentTable";

import WorkerTable from "@/components/Broker/Worker/WorkerTable";

import TaskTable from "@/components/Task/TaskTable";

import PrinterQueueTable from "@/components/CoreMaterial/PrinterQueue/PrinterQueueTable";
import PrinterQueueDetail from "@/components/CoreMaterial/PrinterQueue/PrinterQueueDetail";
import MaterialLocationTable from "@/components/CoreMaterial/MaterialLocation/MaterialLocationTable";
import MaterialLocationDetail from "@/components/CoreMaterial/MaterialLocation/MaterialLocationDetail";
import MaterialTable from "@/components/CoreMaterial/Material/MaterialTable";
import MaterialDetail from "@/components/CoreMaterial/Material/MaterialDetail";
// import MaterialActionPanel from "@/components/CoreMaterial/ActionPanel/MaterialActionPanel";
import MaterialCardList from "@/components/CoreMaterial/Material/MaterialCardList";
import MaterialStepperQR from "@/components/CoreMaterial/MaterialStepper/MaterialStepperQR";
// import MaterialChangeQuantity from "@/components/CoreMaterial/Material/MaterialChangeQuantity";
// import MaterialSetUsedUp from "@/components/CoreMaterial/Material/MaterialSetUsedUp";
// import MaterialSetLocation from "@/components/CoreMaterial/Material/MaterialSetLocation";
// import MaterialLotSetLocation from "@/components/CoreMaterial/Material/MaterialLotSetLocation";
import MaterialEventTable from "@/components/CoreMaterial/MaterialEvent/MaterialEventTable";
import MaterialEventDetail from "@/components/CoreMaterial/MaterialEvent/MaterialEventDetail";

import MaterialDeliveryTable from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryTable";
import MaterialDeliveryDetail from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail";

import PBatchRunItem from "@/components/PBatchRun/BatchRun/PBatchRunItem";
import PBatchRunTable from "@/components/PBatchRun/BatchRun/PBatchRunTable";
import PCustomerOrderSoloItem from "@/components/PBatchRun/CustomerOrderSolo/PCustomerOrderSoloItem";
import PCustomerOrderSoloTable from "@/components/PBatchRun/CustomerOrderSolo/PCustomerOrderSoloTable";
import PVariantSoloItem from "@/components/PBatchRun/VariantSolo/PVariantSoloItem";
import PVariantSoloTable from "@/components/PBatchRun/VariantSolo/PVariantSoloTable";
import PBatchRunTaskItem from "@/components/PBatchRun/BatchRunTask/PBatchRunTaskItem";
import PBatchRunTaskTable from "@/components/PBatchRun/BatchRunTask/PBatchRunTaskTable";
import PVariantTaskItem from "@/components/PBatchRun/VariantTask/PVariantTaskItem";
import PVariantTaskTable from "@/components/PBatchRun/VariantTask/PVariantTaskTable";

import SimpleMainTable from "@/components/Common/Example/SimpleMainTable";
import SimpleMainDetail from "@/components/Common/Example/SimpleMainDetail";
import SimpleChildTable from "@/components/Common/Example/SimpleChildTable";
import SimpleChildDetail from "@/components/Common/Example/SimpleChildDetail";

import SystemPanel from "@/components/SystemPanel/SystemPanel";
import CoreChangeLogTable from "@/components/CoreChangeLog/CoreChangeLogTable";
import CoreChangeLogDetail from "@/components/CoreChangeLog/CoreChangeLogDetail";

import TestScanner from "@/components/CoreMaterial/TestScanner/TestScanner";

import RequestRawTable from "@/components/Panasonic/RequestRawTable";
import RequestRawDetail from "@/components/Panasonic/RequestRawDetail";


Vue.use(VueRouter)

const Foo = {template: '<div>foo</div>'}

const routes = [
    // {
    //     path: '/mpnresearch_test/:itemId/',
    //     name: 'MPNResearchTest',
    //     component: MPNResearchTest,
    //     meta: {guest: false},
    //     props: true,
    // },
    {
        path: '/test/reference_model/',
        name: 'TestReferenceModel',
        component: TestReferenceModel,
        meta: {guest: false},
        props: true,
    },
    {
        path: '/auth_login/',
        name: 'AuthLogin',
        component: AuthLogin,
        meta: {guest: true},
    },
    {
        path: '/auth_logout/',
        name: 'AuthLogout',
        component: AuthLogout,
        meta: {requiresAuth: true},
    },
    {
        path: '/batch_run_history/:itemId/',
        name: 'BatchRunHistoryItem',
        component: BatchRunHistoryItem,
        meta: {requiresAuth: true, showModal: false},
        props: true,
    },
    {
        path: '/batch_run/',
        name: 'BatchRun',
        component: BatchRun,
        meta: {requiresAuth: true},
    },
    {
        path: '/batch_run_history/',
        name: 'BatchRunHistoryList',
        component: BatchRunHistoryList,
        meta: {requiresAuth: true},
        props: true,
        children: [
            {
                path: 'batch_run_history/:itemId/',
                name: 'BatchRunHistoryList_BatchRunHistoryItem',
                component: BatchRunHistoryItem,
                meta: {requiresAuth: true, showModal: true},
                props: true,
            },
        ]
    },
    // {
    //     path: '/batch_run/delivery/:itemUid/',
    //     name: 'DeliveryItem',
    //     component: DeliveryItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    {
        path: '/batch_run/batch_run',
        name: 'BatchRunTable',
        component: BatchRunTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/batch_run/batch_run/:itemUid/',
        name: 'BatchRunItem',
        component: BatchRunItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/account_permission/',
        name: 'AccountPermissionGroupList',
        component: AccountPermissionGroupList,
        meta: {requiresAuth: true},
    },
    {
        path: '/superbom/:superBomId/',
        name: 'SuperBom',
        component: SuperBom,
        meta: {requiresAuth: true},
    },
    {
        path: '/superbom/',
        name: 'SuperBomList',
        component: SuperBomList,
        meta: {requiresAuth: true},
    },
    {
        path: '/brand/',
        name: 'BrandList',
        component: BrandList,
        meta: {requiresAuth: true},
    },
    {
        path: '/provider/',
        name: 'BrandProviderList',
        component: BrandProviderList,
        meta: {requiresAuth: true},
    },
    {
        path: '/provider/:brandProviderId',
        name: 'BrandProviderItem',
        component: BrandProviderItem,
        meta: {requiresAuth: true},
    },
    {
        path: '/component/',
        name: 'BrandComponentList',
        component: BrandComponentList,
        meta: {requiresAuth: true},
    },
    {
        path: '/component/:brandComponentId',
        name: 'BrandComponentItem',
        component: BrandComponentItem,
        meta: {requiresAuth: true},
    },
    {
        path: '/provider_component',
        name: 'BrandComponentProviderComponent',
        component: BrandComponentProviderComponent,
        meta: {requiresAuth: true},
    },

    // {path: '/mpnresearch', name: 'MPNResearch', component: MPNResearch, meta: {requiresAuth: true},},
    // {
    //     path: '/mpnresearch/:bomMpnResearchId',
    //     name: 'MPNResearchItem',
    //     component: MPNResearchItem,
    //     meta: {requiresAuth: true},
    // },

    // {path: '/bom/', name: 'Bom', component: Bom, meta: {requiresAuth: true},},
    // {
    //     path: '/bom/:itemId',
    //     name: 'BomSheetPage',
    //     component: BomSheetPage,
    //     props: true,
    //     meta: {requiresAuth: true},
    // },

    {path: '/time_tracker/', name: 'TimeTracker', component: TimeTracker, meta: {requiresAuth: true},},
    {
        path: '/time_tracker/:itemId',
        name: 'TimeTrackerPage',
        component: TimeTrackerHumanInfoModal,
        props: true,
        meta: {requiresAuth: true},
    },
    {
        path: '/time_tracker/human_info',
        name: 'TimeTrackerHumanInfo',
        component: TimeTrackerHumanInfo,
        props: true,
        meta: {requiresAuth: true},
    },


    {path: '/time_tracker_event/', name: 'HRAdmin', component: HRAdmin, meta: {requiresAuth: true},},
    {path: '/human_user_config/', name: 'HRConfig', component: HRConfig, meta: {requiresAuth: true},},
    {
        path: '/calendar_date/vacation/',
        name: 'CalendarVacationTable',
        component: CalendarVacationTable,
        meta: {requiresAuth: true},
    },

    {path: '/human_user_contract/', name: 'Contract', component: Contract, meta: {requiresAuth: true},},

    {
        path: '/time_tracker_aggregate_event/',
        name: 'TimeTrackerAggregateEvent',
        component: TimeTrackerAggregateEvent,
        meta: {requiresAuth: true},
    },

    {
        path: '/mpncheckingitem/:itemId/',
        name: 'MPNCheckingItem',
        component: MPNCheckingItem,
        meta: {requiresAuth: true, showModal: false},
        props: true,
    },
    {
        path: '/mpnchecking/', name: 'MPNChecking', component: MPNChecking, meta: {requiresAuth: true}, props: true,
        children: [
            {
                path: 'mpncheckingitem/:itemId/',
                name: 'MPNChecking_MPNCheckingItem',
                component: MPNCheckingItem,
                meta: {requiresAuth: true, showModal: true},
                props: true,
            },
        ]
    },

    {path: '/task/:taskId', name: 'BaseTaskView', component: BaseTaskView, meta: {requiresAuth: true}, props: true,},

    {path: '/store_doc', name: 'StoreDocList', component: StoreDocList, meta: {requiresAuth: true},},
    {
        path: '/store_doc/:storeDocItemId/:searchTermFile',
        name: 'StoreDocItem',
        component: StoreDocItem,
        meta: {requiresAuth: true},
        props: true,
    },
    {path: '/store_file', name: 'StoreFileList', component: StoreFileList, meta: {requiresAuth: true},},

    {
        path: '/quote/:itemId/',
        name: 'QuoteItem',
        component: QuoteItem,
        meta: {requiresAuth: true, showModal: false},
        props: true,
        children: [
            {
                path: 'history_file/:storeDocItemId/',
                name: 'QuoteItem_BaseHistoryFile',
                component: BaseHistoryFile,
                meta: {requiresAuth: true, showModal: true},
                props: true,
            },
        ],
    },
    {
        path: '/quote/', name: 'QuoteList', component: QuoteList, meta: {requiresAuth: true}, props: true,
        children: [
            {
                path: 'quote/:itemId/',
                name: 'QuoteList_QuoteItem',
                component: QuoteItem,
                meta: {requiresAuth: true, showModal: true},
                props: true,
                children: [
                    {
                        path: 'history_file/:storeDocItemId/',
                        name: 'QuoteList_QuoteItem_BaseHistoryFile',
                        component: BaseHistoryFile,
                        meta: {requiresAuth: true, showModal: true},
                        props: true,
                    },
                ],
            },
        ]
    },
    {
        path: '/base_history/:storeDocItemId',
        name: 'BaseHistory',
        component: BaseHistory,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/history_file/:storeDocItemId/',
        name: 'BaseHistoryFile',
        component: BaseHistoryFile,
        meta: {requiresAuth: true, showModal: false},
        props: true,
    },
    {path: '/', name: 'Home', component: Home, meta: {guest: true, requiresAuth: false},},

    {
        path: '/product/customer/',
        name: 'CustomerTable',
        component: CustomerTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/customer/:itemUid/',
        name: 'CustomerItem',
        component: CustomerItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/product/',
        name: 'CoreProductTable',
        component: CoreProductTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/product/:uidItem/',
        name: 'CoreProductDetail',
        component: CoreProductDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/client_replica/',
        name: 'ClientReplicaTable',
        component: ClientReplicaTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/client_replica/:uidItem/',
        name: 'ClientReplicaDetail',
        component: ClientReplicaDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/customer_order_replica/',
        name: 'CustomerOrderReplicaTable',
        component: CustomerOrderReplicaTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/customer_order_replica/:uidItem/',
        name: 'CustomerOrderReplicaDetail',
        component: CustomerOrderReplicaDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/quote_replica/',
        name: 'QuoteReplicaTable',
        component: QuoteReplicaTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/quote_replica/:uidItem/',
        name: 'QuoteReplicaDetail',
        component: QuoteReplicaDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/product/product_replica/',
        name: 'ProductReplicaTable',
        component: ProductReplicaTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/product_replica/:uidItem/',
        name: 'ProductReplicaDetail',
        component: ProductReplicaDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/product/batch_run_replica/',
        name: 'BatchRunReplicaTable',
        component: BatchRunReplicaTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/batch_run_replica/:uidItem/',
        name: 'BatchRunReplicaDetail',
        component: BatchRunReplicaDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/product/product_order/',
        name: 'CoreProductOrderTable',
        component: CoreProductOrderTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/product_order/:uidItem/',
        name: 'CoreProductOrderDetail',
        component: CoreProductOrderDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/product/batch_run/',
        name: 'CoreBatchRunTable',
        component: CoreBatchRunTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/batch_run/:uidItem/',
        name: 'CoreBatchRunDetail',
        component: CoreBatchRunDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/product/customer_order/',
        name: 'CustomerOrderTable',
        component: CustomerOrderTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/customer_order/:uidItem/',
        name: 'CustomerOrderDetail',
        component: CustomerOrderDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/machine/',
        name: 'MachineTable',
        component: MachineTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/machine/:itemUid/',
        name: 'MachineItem',
        component: MachineItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/task_type/',
        name: 'TaskTypeTable',
        component: TaskTypeTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/task_type/:itemUid/',
        name: 'TaskTypeItem',
        component: TaskTypeItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/task_template/',
        name: 'TaskTemplateTable',
        component: TaskTemplateTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/task_template/:itemUid/',
        name: 'TaskTemplateItem',
        component: TaskTemplateItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/product/task_template_one/',
        name: 'TaskTemplateOneTable',
        component: TaskTemplateOneTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/product/task_template_one/:itemUid/',
        name: 'TaskTemplateOneItem',
        component: TaskTemplateOneItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/library/file/',
        name: 'LibraryFileTable',
        component: LibraryFileTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/library/file/:itemUid/',
        name: 'LibraryFileItem',
        component: LibraryFileItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/library/doc/',
        name: 'LibraryDocTable',
        component: LibraryDocTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/library/doc/:itemUid/',
        name: 'LibraryDocItem',
        component: LibraryDocItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/library/topic/',
        name: 'LibraryTopicTable',
        component: LibraryTopicTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/library/topic/:itemUid/',
        name: 'LibraryTopicItem',
        component: LibraryTopicItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/history/history/',
        name: 'HistoryTable',
        component: HistoryTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/history/history/:itemUid/',
        name: 'HistoryItem',
        component: HistoryItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/users/user/',
        name: 'UserTable',
        component: UserTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/users/user/:itemUid/',
        name: 'UserItem',
        component: UserItem,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/users/group/',
        name: 'GroupTable',
        component: GroupTable,
        meta: {requiresAuth: true},
        props: true,
    },

    // {
    //     path: '/mcomponent/bom/',
    //     name: 'BomTable',
    //     component: BomTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/bom/:itemUid/',
    //     name: 'BomItem',
    //     component: BomItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/pick_place/:itemUid/',
    //     name: 'PickPlaceItem',
    //     component: PickPlaceItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/bom_sheet/',
    //     name: 'BomSheetTable',
    //     component: BomSheetTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/bom_sheet/:itemUid/',
    //     name: 'BomSheetItem',
    //     component: BomSheetItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/component/',
    //     name: 'ComponentTable',
    //     component: ComponentTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/component/:itemUid/',
    //     name: 'ComponentItem',
    //     component: ComponentItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    {
        path: '/core_component/component/',
        name: 'CoreComponentTable',
        component: CoreComponentTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/component/:uidItem/',
        name: 'ComponentDetail',
        component: ComponentDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/core_component/category/',
        name: 'CoreCategoryTable',
        component: CoreCategoryTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/category/:uidItem/',
        name: 'CoreCategoryDetail',
        component: CoreCategoryDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/core_component/spec_attr/',
        name: 'CoreSpecAttrTable',
        component: CoreSpecAttrTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/spec_attr/:uidItem/',
        name: 'CoreSpecAttrDetail',
        component: CoreSpecAttrDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    {
        path: '/core_component/spec_attr_component/',
        name: 'CoreSpecAttrComponentTable',
        component: CoreSpecAttrComponentTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/spec_attr_component/:uidItem/',
        name: 'CoreSpecAttrComponentDetail',
        component: CoreSpecAttrComponentDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },
    // {
    //     path: '/core_component/bom/',
    //     name: 'CoreBomTable',
    //     component: CoreBomTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/core_component/bom/:uidItem/',
    //     name: 'CoreBomDetail',
    //     component: CoreBomDetail,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    {
        path: '/core_component/bom_sheet/',
        name: 'CoreBomSheetTable',
        component: CoreBomSheetTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/bom_sheet/:uidItem/',
        name: 'CoreBomSheetDetail',
        component: CoreBomSheetDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/core_component/pick_place_sheet/',
        name: 'CorePickPlaceSheetTable',
        component: CorePickPlaceSheetTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_component/pick_place_sheet/:uidItem/',
        name: 'CorePickPlaceSheetDetail',
        component: CorePickPlaceSheetDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    // {
    //     path: '/mcomponent/component_one/:itemUid/',
    //     name: 'ComponentOneItem',
    //     component: ComponentOneItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/type_category_package/',
    //     name: 'TypeCategoryPackageTable',
    //     component: TypeCategoryPackageTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/type_category_package/:itemUid/',
    //     name: 'TypeCategoryPackageItem',
    //     component: TypeCategoryPackageItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    //
    // {
    //     path: '/mcomponent/provider/',
    //     name: 'ProviderTable',
    //     component: ProviderTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/provider/:itemUid/',
    //     name: 'ProviderItem',
    //     component: ProviderItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    //
    // {
    //     path: '/mcomponent/provider_component/',
    //     name: 'ProviderComponentTable',
    //     component: ProviderComponentTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/provider_component/:uidItem/',
    //     name: 'ProviderComponentDetail',
    //     component: ProviderComponentDetail,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },

    {
        path: '/mcomponent/part_number/',
        name: 'PartNumberTable',
        component: PartNumberTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/mcomponent/part_number/:uidItem/',
        name: 'PartNumberDetail',
        component: PartNumberDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/mcomponent/client/',
        name: 'ClientTable',
        component: ClientTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/mcomponent/client/:uidItem/',
        name: 'ClientDetail',
        component: ClientDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    // {
    //     path: '/material/material_change_quantity/',
    //     name: 'MaterialChangeQuantity',
    //     component: MaterialChangeQuantity,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/material/material_set_used_up/',
    //     name: 'MaterialSetUsedUp',
    //     component: MaterialSetUsedUp,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/material/material_set_location/',
    //     name: 'MaterialSetLocation',
    //     component: MaterialSetLocation,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/material/material_lot_set_location/',
    //     name: 'MaterialLotSetLocation',
    //     component: MaterialLotSetLocation,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/material/material_action_panel/',
    //     name: 'MaterialActionPanel',
    //     component: MaterialActionPanel,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    {
        path: '/material/material_registration/:selectedDeliveryUid/',
        name: 'MaterialStepperQR',
        component: MaterialStepperQR,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material_registration/',
        name: 'MaterialStepperQR',
        component: MaterialStepperQR,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material_delivery/',
        name: 'MaterialDeliveryTable',
        component: MaterialDeliveryTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material_delivery/:uidItem/',
        name: 'MaterialDeliveryDetail',
        component: MaterialDeliveryDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

     {
        path: '/material/material_event/',
        name: 'MaterialEventTable',
        component: MaterialEventTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material_event/:uidItem/',
        name: 'MaterialEventDetail',
        component: MaterialEventDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    // {
    //     path: '/mcomponent/category/',
    //     name: 'CategoryTable',
    //     component: CategoryTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/category/:itemUid/',
    //     name: 'CategoryItem',
    //     component: CategoryItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },

    {
        path: '/mcomponent/subcategory/',
        name: 'CoreSubcategoryTable',
        component: CoreSubcategoryTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/mcomponent/subcategory/:uidItem/',
        name: 'CoreSubcategoryDetail',
        component: CoreSubcategoryDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    // {
    //     path: '/mcomponent/component_category_tab/',
    //     name: 'ComponentCategoryTab',
    //     component: ComponentCategoryTab,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },

    {
        path: '/mcomponent/case_package/',
        name: 'CoreCasePackageTable',
        component: CoreCasePackageTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/mcomponent/case_package/:uidItem/',
        name: 'CoreCasePackageDetail',
        component: CoreCasePackageDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/mcomponent/batch_run_component/',
        name: 'BatchRunComponentTable',
        component: BatchRunComponentTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/mcomponent/batch_run_component/:uidItem/',
        name: 'BatchRunComponentDetail',
        component: BatchRunComponentDetail,
        meta: {requiresAuth: true, showModal: true},
        props: true,
    },

    {
        path: '/broker/worker/',
        name: 'WorkerTable',
        component: WorkerTable,
        meta: {requiresAuth: true},
        props: true,
    },

    // {
    //     path: '/mcomponent/octopart_account/',
    //     name: 'OctopartAccountTable',
    //     component: OctopartAccountTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/octopart_account/:itemUid/',
    //     name: 'OctopartAccountItem',
    //     component: OctopartAccountItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    //
    // {
    //     path: '/mcomponent/spec_attr/',
    //     name: 'SpecAttrTable',
    //     component: SpecAttrTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/spec_attr/:itemUid/',
    //     name: 'SpecAttrItem',
    //     component: SpecAttrItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },
    //
    // {
    //     path: '/mcomponent/spec_attr_component/',
    //     name: 'SpecAttrComponentTable',
    //     component: SpecAttrComponentTable,
    //     meta: {requiresAuth: true},
    //     props: true,
    // },
    // {
    //     path: '/mcomponent/spec_attr_component/:itemUid/',
    //     name: 'SpecAttrComponentItem',
    //     component: SpecAttrComponentItem,
    //     meta: {requiresAuth: true, showModal: true},
    //     props: true,
    // },

    {
        path: '/broker/task/',
        name: 'TaskTable',
        component: TaskTable,
        meta: {requiresAuth: true},
        props: true,
    },

    // Material
    {
        path: '/material/printer_queue/',
        name: 'PrinterQueueTable',
        component: PrinterQueueTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/printer_queue/:uidItem/',
        name: 'PrinterQueueDetail',
        component: PrinterQueueDetail,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/location/',
        name: 'MaterialLocationTable',
        component: MaterialLocationTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/location/:uidItem/',
        name: 'MaterialLocationDetail',
        component: MaterialLocationDetail,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material/',
        name: 'MaterialTable',
        component: MaterialTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material/:uidItem/',
        name: 'MaterialDetail',
        component: MaterialDetail,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/material/material_card/',
        name: 'MaterialCardList',
        component: MaterialCardList,
        meta: {requiresAuth: true},
        props: true,
    },

    // BATCH RUN
    {
        path: '/pbatch_run/batch_run/',
        name: 'PBatchRunTable',
        component: PBatchRunTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/pbatch_run/batch_run/:itemUid/',
        name: 'PBatchRunItem',
        component: PBatchRunItem,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/pbatch_run/customer_order_solo/',
        name: 'PCustomerOrderSoloTable',
        component: PCustomerOrderSoloTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/pbatch_run/customer_order_solo/:itemUid/',
        name: 'PCustomerOrderSoloItem',
        component: PCustomerOrderSoloItem,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/pbatch_run/variant_solo/',
        name: 'PVariantSoloTable',
        component: PVariantSoloTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/pbatch_run/variant_solo/:itemUid/',
        name: 'PVariantSoloItem',
        component: PVariantSoloItem,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/pbatch_run/batch_run_task/',
        name: 'PBatchRunTaskTable',
        component: PBatchRunTaskTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/pbatch_run/batch_run_task/:itemUid/',
        name: 'PBatchRunTaskItem',
        component: PBatchRunTaskItem,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/pbatch_run/variant_task/',
        name: 'PVariantTaskTable',
        component: PVariantTaskTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/pbatch_run/variant_task/:itemUid/',
        name: 'PVariantTaskItem',
        component: PVariantTaskItem,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/example/simple_main/',
        name: 'SimpleMainTable',
        component: SimpleMainTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/example/simple_main/:uidItem/',
        name: 'SimpleMainDetail',
        component: SimpleMainDetail,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/example/simple_child/',
        name: 'SimpleChildTable',
        component: SimpleChildTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/example/simple_child/:uidItem/',
        name: 'SimpleChildDetail',
        component: SimpleChildDetail,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/system_panel/',
        name: 'SystemPanel',
        component: SystemPanel,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/core_change_log/',
        name: 'CoreChangeLogTable',
        component: CoreChangeLogTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/core_change_log/:uidItem/',
        name: 'CoreChangeLogDetail',
        component: CoreChangeLogDetail,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/panasonic/request_raw/',
        name: 'RequestRawTable',
        component: RequestRawTable,
        meta: {requiresAuth: true},
        props: true,
    },
    {
        path: '/panasonic/request_raw/:uidItem/',
        name: 'RequestRawDetail',
        component: RequestRawDetail,
        meta: {requiresAuth: true},
        props: true,
    },

    {
        path: '/test/test_scaner/',
        name: 'TestScanner',
        component: TestScanner,
        meta: {requiresAuth: true},
        props: true,
    },

]


function get_routes_with_children(routers) {
    let router_children = []
    for (let router_child of routers) {
        if (router_child.hasOwnProperty('meta') && router_child.meta.showModal === true) {
            // console.log('router_child', router_child)
            let router_child_clone =
                {
                    ...router_child,
                }
            router_child_clone['path'] = router_child_clone.path.slice(1)
            if (!router_child_clone.hasOwnProperty('meta'))
                router_child_clone['meta'] = {}
            let child_meta = router_child_clone.meta
            child_meta['showModal'] = true
            child_meta['mainName'] = router_child_clone.name
            router_child_clone['meta'] = child_meta
            router_children.push(router_child_clone)
        }
    }
    // console.log('router_children', router_children)

    let result_routers = []
    for (let router of routers) {
        // console.log('router', router)
        let router_children_modified = []
        for (let child of router_children) {
            let child_clone = {
                ...child,
                name: router.name + '_' + child.name,
            }
            if ('/' + child_clone.path !== router.path)
                router_children_modified.push(child_clone)
        }
        if (router.path !== '/') {
            if (!router.hasOwnProperty('children'))
                router['children'] = []
            router.children = [
                ...router_children_modified,
                ...router.children,
            ]
        }
        // console.log('new router', router)
        result_routers.push(router)
    }
    return (result_routers)
}

// let routes_with_children = get_routes_with_children(routes)
// console.log('get_routes_with_children', routes_with_children)

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: '/site/',
    // routes: routes_with_children,
    routes: routes,
})

router.beforeEach((to, from, next) => {
    // console.log('from-to', from, to)
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const sessionid = $cookies.get('sessionid')
        if (sessionid != null) {
            next()
            return
        }
        next('/auth_login')
        next({name: 'AuthLogin', query: {from: to.path}});
    } else {
        next()
    }

})


export default router
